<script setup lang="ts">
import { getBusinessCategories } from '@/javascripts/utils/inquiry_form_options';
import Inquiry from '@/javascripts/utils/inquiry';
import SlideIndicator from './slide_indicator.vue';

const emit = defineEmits(['next', 'back']);

const props = defineProps<{
  inquiry: Inquiry,
  currentSlideIndex: number,
}>();

const businessCategories = getBusinessCategories();

const emitNextIfUnchanged = function(clicked: number | string) {
  if (props.inquiry.businessCategoryCd == clicked) {
    emit('next');
  }
}
</script>

<template>
  <div class="inner_content inner_step">
    <div class="main_content step_content">
      <SlideIndicator :current-slide-index="currentSlideIndex" />
      <h2>あなたのご希望の業種は？</h2>
      <div class="box_step_btn box_step_btn_p01">
        <div
          v-for="businessCategory in businessCategories"
          :key="businessCategory.cd"
          class="step_btn"
        >
          <label :for="`business_${businessCategory.cd}`">
            <input
              :id="`business_${businessCategory.cd}`"
              v-model="inquiry.businessCategoryCd"
              type="radio"
              name="business_cd"
              :value="businessCategory.cd"
              @change="emit('next')"
              @click="emitNextIfUnchanged(businessCategory.cd)"
            >
            <p>{{ businessCategory.text }}</p>
          </label>
        </div>
      </div>
      <div class="box_btn_nextback">
        <div class="btn_back">
          <button @click.once="emit('back')">
            <span>戻る</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
